import { Stack } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { usePoliciesForPolicyholder } from '../../api/PolicyholderApi';
import { useAuthContext } from '../../context/auth';
import { getPolicyStatus } from '../../util/util';
import NewApplicationsTable from './NewApplicationsTable';
import NewPoliciesTable from './NewPoliciesTable';

const PoliciesView = () => {
	const authData = useAuthContext();
	const params = useParams();
	const { policyholderId } = params;

	const authToken = authData.auth.authorizationToken;

	const {
		data,
		isLoading: isPolicyholderSearchLoading,
		isRefetching: isPolicyholderSearchRefetching,
	} = usePoliciesForPolicyholder(policyholderId, authToken);

	const applications = data?.policies?.filter((policy) => {
		const policyGraceLapse = data?.graceLapseReinstatementData.find((g) =>
			g ? g.gracePeriod.policyLocator === policy.locator : null,
		);
		const state = getPolicyStatus(policy, policyGraceLapse);
		return !policy.issuedTimestamp && state !== 'Accepted';
	});

	const issuedPolicies = data?.policies?.filter((policy) => {
		const policyGraceLapse = data?.graceLapseReinstatementData.find((g) =>
			g ? g.gracePeriod.policyLocator === policy.locator : null,
		);
		const state = getPolicyStatus(policy, policyGraceLapse);
		return policy.issuedTimestamp || state === 'Accepted';
	});

	return (
		<Stack spacing={8}>
			<NewApplicationsTable
				policies={applications || []}
				graceLapses={data?.graceLapseReinstatementData}
				loading={isPolicyholderSearchLoading}
				isRefetching={isPolicyholderSearchRefetching}
			/>
			<NewPoliciesTable
				policies={issuedPolicies || []}
				graceLapses={data?.graceLapseReinstatementData}
				loading={isPolicyholderSearchLoading}
				isRefetching={isPolicyholderSearchRefetching}
			/>
		</Stack>
	);
};

export default PoliciesView;
